import {Box, Flex, Image, Paper, Text, TypographyStylesProvider} from "@mantine/core";
export default function _Posts({component}){

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                // bg={component?.customize_styles?.text_decoration?.background_color}
                fz={component?.customize_styles?.text_decoration?.font_size}
                fw={component?.customize_styles?.text_decoration?.font_weight}
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
            >
                {component?.customize_properties?.label}
            </Text>

            {
                component?.items?.map((item, index) => (
                    <Paper
                        key={item.ID}
                        mx={component?.customize_styles?.box_decoration?.margin_x}
                        my={component?.customize_styles?.box_decoration?.margin_y}
                        px={component?.customize_styles?.box_decoration?.padding_x}
                        py={component?.customize_styles?.box_decoration?.padding_y}
                        bg={component?.customize_styles?.box_decoration?.background_color}
                        pos="relative"
                        style={{
                            boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                            borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                            border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                        }}
                    >
                        <Flex
                            direction="column"
                            justify="center"
                            align="flex-start"
                        >
                            <Image
                                src={item.feature_image_url}
                                fit="contain"
                                radius={component?.customize_styles?.image_decoration?.radius}
                            />
                            <Text
                                lineClamp={1}
                                translate="yes"
                                c={component?.customize_styles?.name_text_decoration?.color}
                                fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                fz={component?.customize_styles?.name_text_decoration?.font_size}
                                fs={component?.customize_styles?.name_text_decoration?.font_style}
                            >
                                {item.post_title}
                            </Text>
                            <Text c="#989898" fz="xs">{item.post_date}</Text>

                            <Text lineClamp={3} component="div">
                                <TypographyStylesProvider>
                                    <div
                                        dangerouslySetInnerHTML={{__html: item.post_excerpt}}
                                    >
                                    </div>
                                </TypographyStylesProvider>
                            </Text>
                            <Text c="#E88508" fz="xs">Read more...</Text>
                        </Flex>
                    </Paper>
                ))
            }
        </Box>
    )
}